import helpers from './helpers';

export default function ProtectedComponent({ account, requiredPermissions=[], children }) {
    const is_authorized = helpers.checkPermissions(requiredPermissions, account?.permissions);

    if(requiredPermissions.length && !is_authorized){
        return
    }

    return children;
}